module.exports = __webpack_public_path__ + "static/fonts/iconfont.121c372e.woff2";